"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ART_MARKUP_AVAILABILITY = exports.ART_MARKUP_BRAND = exports.ART_MARKUP_DESCRIPTION = void 0;
exports.ART_MARKUP_DESCRIPTION = 'Shop online beautiful & affordable framed art prints. Curated artworks by the world’s best artists.\n' +
    'High-definition art prints with top quality frames. Frames are restickable with no wall damage! Say goodbye to nails and hello to mixtiles art.\n' +
    'Simply choose the art & framing design to suit your decor.\n' +
    'Delivered right to your door and ready to hang! Shipping is fast and always free.\n' +
    'Available in multiple sizes & frames\n';
exports.ART_MARKUP_BRAND = 'Mixtiles Art';
exports.ART_MARKUP_AVAILABILITY = 'https://schema.org/InStock';
//# sourceMappingURL=googleMarketingMarkup.js.map